import { CDN_DOMAIN, CDN_DOMAIN_INTL, CDN_DOMAIN_OLD, NEW_CDN_DOMAIN } from '../constants';

// 非开发环境，配置crossorigin
const corsEnable = process.env.ZONE_ENV ? { crossorigin: '' } : {};

/**
 * 非开发环境并且链接包含CDN_DOMAIN，配置crossorigin
 * @param src
 * @returns {{crossorigin: string}}
 */
function corsEnableForCDN(src) {
  let crossoriginRes = {};
  if (process.env.ZONE_ENV) {
    // 检查常见的CDN和外部域名
    const externalDomains = [
      CDN_DOMAIN,
      NEW_CDN_DOMAIN,
      CDN_DOMAIN_OLD,
      CDN_DOMAIN_INTL,
    ];
    const isExternal = externalDomains.some((domain) => src.includes(domain))
                       || /^https?:\/\//.test(src);
    if (isExternal) {
      crossoriginRes = { crossorigin: 'anonymous' };
    }
  }
  return crossoriginRes;
}

// 冒泡排序
function bubble(arr, str) {
  for (let i = 0; i < arr.length - 1; i++) {
    for (let j = 0; j < arr.length - 1 - i; j++) {
      const isUP = new Date(arr[j][str]) < new Date(arr[j + 1][str]);
      if (isUP) {
        const tempItem = arr[j];
        arr[j] = arr[j + 1];
        arr[j + 1] = tempItem;
      }
    }
  }
  return arr;
}

export { bubble, corsEnable, corsEnableForCDN };
